export default __webpack_public_path__ + "static/media/dummy-car.622b3e01.svg";